import { FieldSelect } from 'components/form';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useCallback, useState } from 'react';
import { useGeneralImpressions } from 'api/hooks';

export default function GeneralImpressionsFilter({ onChange, ...rest }) {
  const { impressions, isLoading } = useGeneralImpressions({});
  const [selectedValue, setSelectedValue] = useState();

  const onSelect = useCallback(
    (option) => {
      setSelectedValue(option);
      onChange(option);
    },
    [onChange],
  );
  return (
    <FieldSelect
      value={selectedValue}
      onChange={(_value, option) => onSelect(option)}
      options={impressions ?? []}
      isLoading={isLoading}
      focusColor="indigo"
      {...rest}
    />
  );
}

GeneralImpressionsFilter.propTypes = {
  onChange: PropTypes.func,
};
GeneralImpressionsFilter.defaultProps = {
  onChange: _.noop,
};
